import { render, staticRenderFns } from "./DropdownFilter.vue?vue&type=template&id=245e9c9f&scoped=true&"
import script from "./DropdownFilter.vue?vue&type=script&lang=js&"
export * from "./DropdownFilter.vue?vue&type=script&lang=js&"
import style0 from "./DropdownFilter.vue?vue&type=style&index=0&id=245e9c9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e9c9f",
  null
  
)

export default component.exports